

import { Component, Prop, Vue } from 'vue-property-decorator'
import { IPost } from '~/interfaces/post'
import { PostCardLayout } from '~/interfaces/components'
import AppLink from '~/components/shared/app-link.vue'

@Component({
    components: { AppLink }
})
export default class PostCard extends Vue {
    @Prop({ type: String, default: () => undefined }) readonly layout!: PostCardLayout
    @Prop({ type: Object, required: true }) readonly post!: IPost

    get cardClasses () {
        return [
            'post-card',
            {
                'post-card--layout--grid': this.layout && ['grid-nl', 'grid-lg'].includes(this.layout),
                'post-card--layout--list': this.layout && ['list-nl', 'list-sm'].includes(this.layout),
                'post-card--size--nl': this.layout && ['grid-nl', 'list-nl'].includes(this.layout),
                'post-card--size--lg': this.layout === 'grid-lg',
                'post-card--size--sm': this.layout === 'list-sm'
            }
        ]
    }
}

